// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"6ea4cf9e","190":"28055d8d","337":"b3ee8532","531":"ae4b7a07","803":"c2e8fc4d","965":"48227aaf"}[chunkId] + ".chunk.js";
};